import PropTypes from 'prop-types';

export const propTypes = {
  clearFilters: PropTypes.func.isRequired,
};
